import { Text, Heading, LiliButton, FontWeight } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import LiliLogo from '@Assets/logos/lili-logo-blue.svg';
import WelcomeRankingBanner from '@Assets/banners/welcome-ranking.svg';

import { useBoundStore } from '@Store/useBoundStore';
import { useNavigationManager } from '@Router/useNavigationManager';
import { RoutesMap } from '@Router/router.types';
import { useStartMfaPhoneVerification } from './hooks/startMfaPhoneVerification';
import { UboOnboardingAnalyticsService } from './UboAnalytcs.service';

export const UboOnboardingIntro = () => {
  const { t } = useTranslation();

  const customerId = useBoundStore((state) => state.secondaryCustomerId!);
  const setUboData = useBoundStore((state) => state.setUboData);

  const { mutateAsync: startMfaPhoneVerification, isPending } = useStartMfaPhoneVerification({
    customerId,
  });

  const {
    customer: { customerData },
    setCustomerData,
  } = useBoundStore((state) => state);
  // set first name in the customer data for the success page

  const uboData = useBoundStore((state) => state.uboData);
  useEffect(() => {
    setCustomerData({
      customerData: {
        ...customerData,
        firstName: uboData?.secondaryCustomerDetails.firstName,
      },
    });
    UboOnboardingAnalyticsService.trackUboOnboardingStart();
  }, []);
  const { navigateToNextPage } = useNavigationManager();

  const handleStart = async () => {
    const response = await startMfaPhoneVerification();
    if (response?.mfaDestination && uboData) {
      setUboData({ ...uboData, mfaDestination: response.mfaDestination });
    }
    navigateToNextPage(RoutesMap.UBO_ONBOARDING_INTRO);
  };
  const firstName = uboData?.primaryCustomerDetails.firstName || '';
  const lastName = uboData?.primaryCustomerDetails.lastName || '';
  const customerName = `${firstName} ${lastName}`;
  const businessName = uboData?.businessDetails.name || '';

  return (
    <div className='flex flex-col items-center justify-center w-full'>
      <div className='flex flex-col items-center mt-[240px] min-h-screen md:max-w-[450px] max-w-[340px]'>
        <img
          src={LiliLogo}
          alt={t('pages.uboOnboarding.logoAlt')}
          className='w-[94px] justify-self-center mb-[24px]'
        />
        <div id='mainContent' className='flex flex-col text-center w-full items-center gap-[52px]'>
          <div>
            <Heading.H3 fontWeight={FontWeight.SEMIBOLD} className='mb-[4px]'>
              {t('pages.uboOnboarding.welcomeHeader')}
            </Heading.H3>
            <Heading.H7>{t('pages.uboOnboarding.welcomeSubheader')}</Heading.H7>
          </div>

          <Text.H9 className='text-text-main-secondary'>
            {t('pages.uboOnboarding.description', { customerName, businessName })}
          </Text.H9>

          <LiliButton
            id='get-started-button'
            title={t('pages.uboOnboarding.getStarted')}
            onClick={handleStart}
            isLoading={isPending}
          />
        </div>
      </div>
      <div className='flex flex-row gap-4 items-center absolute bottom-[40px] left-1/2 -translate-x-1/2'>
        <img
          className='w-[320px]'
          src={WelcomeRankingBanner}
          alt={t('pages.uboOnboarding.trustPilotAlt')}
        />
      </div>
    </div>
  );
};

export default UboOnboardingIntro;
